import styled from 'styled-components';
import { breakpoints } from '../../../assets/styles/GlobalStyles';

// Estilos compartilhados entre os componentes da pasta address/

/**
 * Card container para cada seção de endereço (residencial/comercial)
 */
export const Section = styled.section`
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid #e8ecef;
`;

/**
 * Grid de duas colunas para campos relacionados (ex: número/complemento);
 * empilha em uma coluna quando o espaço aperta (tablet) e sempre abaixo de 768px.
 */
export const Row = styled.div`
  display: grid;
  // Até 2 colunas; cai para 1 quando cada uma ficaria com menos de 220px (ex. tablet)
  grid-template-columns: repeat(auto-fit, minmax(min(100%, max(220px, calc(50% - 0.5rem))), 1fr));
  gap: 1rem;
  margin-bottom: 1rem;

  @media (max-width: ${breakpoints.mobile}) {
    grid-template-columns: 1fr;
  }
`;
